(function () {

  function initScrollReveal() {

    const elements = document.querySelectorAll(
      '[data-reveal]'
    );

    if (!elements.length) return;


    /*
      Respect reduced motion preference.
    */
    const prefersReducedMotion =
      window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches;


    if (prefersReducedMotion) {

      elements.forEach(function (element) {
        element.classList.add('is-visible');
      });

      return;
    }


    /*
      Create observer.
    */
    const observer = new IntersectionObserver(
      function (entries) {

        entries.forEach(function (entry) {

          if (entry.isIntersecting) {

            /*
              Element enters viewport.
            */
            entry.target.classList.add(
              'is-visible'
            );

          } else {

            /*
              Element leaves viewport.

              Remove class so animation
              can play again when scrolling
              back in the opposite direction.
            */
            entry.target.classList.remove(
              'is-visible'
            );

          }

        });

      },
      {
        threshold: 0.15,
        rootMargin: '0px 0px -8% 0px'
      }
    );


    /*
      Observe every reveal element.
    */
    elements.forEach(function (element) {
      observer.observe(element);
    });

  }


  /*
    Initial page load.
  */
  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      initScrollReveal
    );

  } else {

    initScrollReveal();

  }


  /*
    Shopify Theme Editor support.
  */
  document.addEventListener(
    'shopify:section:load',
    function () {
      initScrollReveal();
    }
  );

})();